import React from "react";
import { motion } from "framer-motion";
import Head from "./Head";
import Body from "./Body";
import classNames from "../../classNames";
import { AnimatePresence } from "framer-motion";

const noop = () => {};
const defaultProps = {
  fields: {},
  objects: [],
  excludeFields: [],
  selected: [],
  progress: false,
  onClick: noop,
  onClickItem: noop,
  onSelect: noop,
  onSelectAll: noop,
  readOnly: false,
  actions: [],
  actionsList: [],
  selectable: false,
  collapsable: false,
  toggleable: false,
  onCollapse: noop,
  onLongPress: noop,
};

function isSelectable(object, unselectable) {
  if (!unselectable || Object.keys(unselectable).length === 0) return true;
  return !Object.entries(unselectable).some(
    ([key, value]) => object.hasOwnProperty(key) && object[key] === value,
  );
}

function Table({
  className,
  fields,
  objects,
  progress,
  onClick,
  onClickItem,
  selected,
  onSelect,
  onSort,
  onSelectAll,
  excludeFields,
  actions,
  actionsList,
  setRef,
  selectable,
  onCollapse,
  collapsable,
  toggleable,
  onLongPress,
  onToggleBoolean,
  onEdit,
  style,
  numbering = true,
  showActions = true,
  unselectable,
  ...props
}) {
  const selectableObjects =
    selectable && unselectable && Object.keys(unselectable).length > 0
      ? objects.filter((o) => isSelectable(o, unselectable))
      : objects;

  const fieldImage = Object.keys(fields).find(
    (field) =>
      (fields[field]._type === "Image" && fields[field].read !== false) ||
      fields[field].detail,
  );

  return (
    <div className="position-relative">
      <div
        className={classNames("table-responsive shadow-sm", className)}
        ref={setRef}
        {...props}
      >
        <table className="table mb-0 w-100 table-striped">
          <thead className="" style={{ backgroundColor: "yellow" }}>
            <Head
              selectable={selectable}
              fields={fields}
              excludeFields={excludeFields}
              actionsList={actionsList}
              selected={selected}
              onSelectAll={onSelectAll}
              objects={objects}
              selectableObjects={selectableObjects}
              unselectable={unselectable}
              numbering={numbering}
              onSort={onSort}
            />
          </thead>

          <tbody className="bg-white">
            {objects.length === 0 && !progress && (
              <motion.tr
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.2 }}
              >
                <td
                  className="text-center text-muted py-5 px-4"
                  colSpan={Object.keys(fields).length + 1}
                >
                  <div className="d-flex flex-column align-items-center justify-content-center gap-2 mx-auto">
                    <i
                      className="bi bi-table opacity-50"
                      style={{ fontSize: "1.75rem" }}
                    />
                    <span
                      className="fw-normal"
                      style={{ fontSize: "0.9rem", letterSpacing: "0.02em" }}
                    >
                      No Data Found
                    </span>
                  </div>
                </td>
              </motion.tr>
            )}
            <Body
              objects={objects}
              fields={fields}
              excludeFields={excludeFields}
              selected={selected}
              selectable={selectable}
              onSelect={onSelect}
              onClick={onClick}
              onLongPress={onLongPress}
              actionsList={actionsList}
              collapsable={collapsable}
              toggleable={toggleable}
              onCollapse={onCollapse}
              actions={actions}
              onClickItem={onClickItem}
              fieldImage={fieldImage}
              numbering={numbering}
              onToggleBoolean={onToggleBoolean}
              unselectable={unselectable}
              onEdit={onEdit}
              showActions={showActions}
              {...props}
            />

            <AnimatePresence mode="popLayout" presenceAffectsLayout>
              {progress &&
                [0.4, 0.25, 0.1].map((item) => {
                  return (
                    <motion.tr
                      key={item}
                      animate={{ opacity: 1 }}
                      initial={{ opacity: 0 }}
                      exit={{ opacity: 0 }}
                    >
                      <td
                        className="w-100 placeholder-glow p-0"
                        style={{
                          height: "2rem",
                          opacity: item,
                        }}
                        colSpan={Object.keys(fields).length + 1}
                      >
                        <div className="h-100 w-100 placeholder col-12"></div>
                      </td>
                    </motion.tr>
                  );
                })}
            </AnimatePresence>
          </tbody>
        </table>
      </div>
    </div>
  );
}

Table.defaultProps = defaultProps;
export default Table;
